import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { setUrls, getUrls } from '../../redux/slices/chatbotSlice';

const WaitForScreen = ({ triggerNextStep }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const urlSelector = useSelector(getUrls);

  const captureScreen = async () => {
    try {
      const stream = await navigator.mediaDevices.getDisplayMedia({
        preferCurrentTab: true,
      });

      return new Promise((resolve, reject) => {
        const video = document.createElement('video');
        video.srcObject = stream;

        video.addEventListener('loadedmetadata', () => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');

          canvas.width = video.videoWidth;
          canvas.height = video.videoHeight;

          video.play();
          ctx.drawImage(video, 0, 0);
          stream.getVideoTracks()[0].stop();
          const dataURL = canvas.toDataURL('image/webp', 1.0);
          const byteString = atob(dataURL.split(',')[1]);

          const mimeString = dataURL.split(',')[0].split(':')[1].split(';')[0];
          const ab = new ArrayBuffer(byteString.length);
          const ia = new Uint8Array(ab);

          for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
          }

          const blob = new Blob([ab], { type: mimeString });
          resolve(blob);

          video.addEventListener('error', error => {
            reject(error);
          });
        });
      });
    } catch (error) {
      return false;
    }
  };

  useEffect(() => {
    const getMediaUrl = async () => {
      const blob = await captureScreen();
      if (blob) {
        dispatch(setUrls([blob]));
        triggerNextStep({ trigger: '6' });
      } else {
        if (urlSelector.length > 0) {
          triggerNextStep({ trigger: '6' });
        } else {
          triggerNextStep({ trigger: 'no-screen' });
        }
      }
    };
    getMediaUrl();
  }, []);

  return <div>{t('botWaitForScreen')}</div>;
};

export default WaitForScreen;
